import { object, string } from 'yup';

import client from '$app-web/core/client';

const requestSchema = object().shape({
    uid: string().required('UID required.'),
    token: string().required('Token required.'),
    password: string().required('New password required.'),
});

const responseSchema = object().shape({
    email: string().required(),
});

const useResetPasswordEndpoint = client.registerEndpoint('POST api/reset-password', 'v1/auth/set_password/', {
    mutate: true,
    requestSchema,
    responseSchema,
});

export default useResetPasswordEndpoint;
